import { render, staticRenderFns } from "./relationEdit.vue?vue&type=template&id=732cce4d&scoped=true"
import script from "./relationEdit.vue?vue&type=script&lang=ts"
export * from "./relationEdit.vue?vue&type=script&lang=ts"
import style0 from "./relationEdit.vue?vue&type=style&index=0&id=732cce4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732cce4d",
  null
  
)

export default component.exports